// src/pages/OtpVerification.js
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/otpregister.css";
import leftImage from "../assets/landing1.png";
import keyIcon from "../assets/key.png";

import { postJson } from "../network/api";
import { ApiEndpoints } from "../network/config";

const OtpVerification = () => {
  const [timeLeft, setTimeLeft] = useState(25);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]); // 🔥 6 digits
  const [canResend, setCanResend] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const mobileNumber = location.state?.mobileNumber || "";

  // Timer logic
  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft((prev) => prev - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setCanResend(true);
    }
  }, [timeLeft]);

  // OTP input change
  const handleOtpChange = (index, value) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Auto-focus next input if not last
      if (value !== "" && index < otp.length - 1) {
        const nextInput = document.getElementById(`otp-input-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  // Backspace handling
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handleResendOtp = () => {
    if (canResend) {
      setTimeLeft(25);
      setCanResend(false);
      setOtp(["", "", "", "", "", ""]);
      const firstInput = document.getElementById("otp-input-0");
      if (firstInput) firstInput.focus();

      
    }
  };

  const formatTime = (seconds) => {
    return `00:${seconds.toString().padStart(2, "0")}`;
  };

  
  const handleVerifyOTP = async () => {
    const enteredOtp = otp.join("");

    if (!mobileNumber) {
      alert("Mobile number missing. Please try registering again.");
      return;
    }

    if (!/^\d{6}$/.test(enteredOtp)) {
      alert("Please enter a valid 6-digit OTP");
      return;
    }

    try {
      
      const result = await postJson(ApiEndpoints.verifyOtp, {
        mobileNumber: mobileNumber.trim(),
        otp: enteredOtp,
      });

      console.log("Verify OTP success:", result);

      
      alert("OTP verified successfully!");

      
      navigate("/signinform", {
        state: {
          mobileNumber,
          purpose: "registration",
        },
      });
    } catch (error) {
      console.error("Verify OTP error:", error);
      alert("Failed to verify OTP. Please eneter corret otp.");
    }
  };

  return (
    <div className="otp-page">
      {/* Left Image Section */}
      <div className="left-side">
        <img src={leftImage} alt="Lingayath Weds" className="left-image" />
      </div>

      {/* Right OTP Verification Section */}
      <div className="right-side">
        <div className="otp-card">
          <h1 className="title">Welcome to Lingayath Weds</h1>

          <div className="otp-header">
            <div className="icon-container">
              <img src={keyIcon} alt="OTP Icon" className="otp-icon" />
            </div>
            <h2 className="otp-title">OTP Verification</h2>
            <p className="otp-message">
              OTP has been sent via SMS to{" "}
              <span className="mobile-number">+91 {mobileNumber}</span>
            </p>
            <p className="otp-instruction">Enter the OTP Below</p>
          </div>

          <form onSubmit={(e) => e.preventDefault()}>
            <div className="otp-inputs">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  className="otp-input"
                  autoFocus={index === 0}
                />
              ))}
            </div>

            <div className="resend-section">
              {canResend ? (
                <button
                  type="button"
                  className="resend-btn"
                  onClick={handleResendOtp}
                >
                  Resend OTP
                </button>
              ) : (
                <p className="resend-timer">
                  Resend OTP in{" "}
                  <span className="time">{formatTime(timeLeft)}</span>
                </p>
              )}
            </div>

            <button
              type="button"
              className="verify-btn"
              onClick={handleVerifyOTP}
            >
              Verify OTP
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OtpVerification;
